import { render, staticRenderFns } from "./CastChart.vue?vue&type=template&id=2f0c5c6e&scoped=true"
import script from "./CastChart.vue?vue&type=script&lang=js"
export * from "./CastChart.vue?vue&type=script&lang=js"
import style0 from "./CastChart.vue?vue&type=style&index=0&id=2f0c5c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c5c6e",
  null
  
)

export default component.exports